import ApiClient from './apiClient';

export const getQRCode = async (content: string): Promise<string> => {
  try {
    const response = await ApiClient.getInstance().get({url: `common/getqrcode?content=${encodeURIComponent(content)}`,});
    return response.data;
  } catch (error) {
    console.error('Failed to fetch QR code:', error);
    throw new Error('Failed to generate QR code');
  }
};

export const formatBase64Image = (
  base64Data: string,
  mimeType = 'image/png'
): string => {
  if (!base64Data) return '';

  if (base64Data.startsWith('data:')) {
    return base64Data;
  }

  // Strip whitespace the API may include in the base64 string — browsers reject
  // data URLs with embedded spaces or newlines and will not render the image.
  return `data:${mimeType};base64,${base64Data.replace(/\s+/g, '')}`;
};
